import { Box, Button, CircularProgress } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

interface ManualReviewActionButtonsProps {
  hasVerifiedPeriods: boolean;
  hasEdits: boolean;
  isVerifying: boolean;
  isEventsInSync: boolean;
  isEditMode: boolean;
  onUnverifyWindow: () => void;
  onVerifyWindow: () => void;
  onEnterEditMode: () => void;
  onSubmitEdits: () => void;
  onCancelEditMode: () => void;
}

export const ManualReviewActionButtons = ({
  hasVerifiedPeriods,
  hasEdits,
  isVerifying,
  isEventsInSync,
  isEditMode,
  onUnverifyWindow,
  onVerifyWindow,
  onEnterEditMode,
  onSubmitEdits,
  onCancelEditMode,
}: ManualReviewActionButtonsProps) => {
  const { t } = useTenantTranslation();

  if (isEditMode) {
    return (
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button variant="outlined" color="primary" onClick={onCancelEditMode}>
          {t("cancelEdit")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onSubmitEdits}
          disabled={isVerifying || !isEventsInSync || !hasEdits}
          startIcon={
            isVerifying ? (
              <CircularProgress size={20} color="inherit" />
            ) : undefined
          }
        >
          {t("submitEdits")}
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      {hasVerifiedPeriods ? (
        <>
          <Button variant="outlined" color="primary" onClick={onEnterEditMode}>
            {t("editWindow")}
          </Button>
          <Button variant="outlined" color="primary" onClick={onUnverifyWindow}>
            {t("unverifyWindow")}
          </Button>
        </>
      ) : null}
      <Button
        variant="outlined"
        color="primary"
        onClick={onSubmitEdits}
        disabled={isVerifying || !isEventsInSync || !hasEdits}
        startIcon={
          isVerifying ? (
            <CircularProgress size={20} color="inherit" />
          ) : undefined
        }
      >
        {t("verifyEdited")}
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={onVerifyWindow}
        disabled={isVerifying || !isEventsInSync}
        startIcon={
          isVerifying ? (
            <CircularProgress size={20} color="inherit" />
          ) : undefined
        }
      >
        {t("verifyWindow")}
      </Button>
    </Box>
  );
};
